const selectors = {
    xpropsLoaded: ({ zoid } = {}) => !!zoid?.xprops,
    getXprops: ({ zoid } = {}) => zoid?.xprops || {},
    getXpropsChildPayload: (state) => {
        const {
            content,
            publisherId,
            channelId,
            queryString,
            UTM,
        } = selectors.getXprops(state)

        const payload = {
            channelId,
            publisherId,
            content,
            queryString,
            UTM,
        }

        return payload
    },
    getChannelId: ({ zoid } = {}) => zoid?.xprops?.channelId || null,
    getTag: ({ zoid } = {}) => zoid?.tag || null,
    getUTM: ({ zoid } = {}) => zoid?.xprops?.UTM || null,
    isEmailLinkExpired: ({ zoid } = {}) => zoid?.xprops?.queryString?.pico_ui === 'emailLinkExpiration',
}

export default selectors
